module.exports = __webpack_public_path__ + "static/img/pay_fail_vava.4016b257.png";